import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useServices } from '../../hooks/useServices';
import '../../styles/DeactivateServiceModal.css';

const DeactivateServiceModal = ({ service, onClose, onSuccess }) => {
  const { toggleServiceStatus } = useServices();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDeactivate = async () => {
    try {
      setLoading(true);
      setError('');

      await toggleServiceStatus(service.id, false);
      onSuccess();
    } catch (error) {
      console.error('Erreur lors de la désactivation:', error);
      setError('Erreur lors de la désactivation du service');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content deactivate-service-modal">
        <div className="modal-header">
          <h2>Désactivation de service</h2>
          <FaTimes className="close-icon" onClick={onClose} />
        </div>

        <div className="modal-body">
          <div className="warning-content">
            <h3>Désactivation de service.</h3>
            <p>
              En désactivant le service, nous enverrons un message
              d'alerte aux prestataires ainsi qu'aux clients pour le
              désagrément.
            </p>
          </div>

          {error && <div className="error-message">{error}</div>}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Annuler
          </button>
          <button 
            className="btn-danger" 
            onClick={handleDeactivate}
            disabled={loading}
          >
            {loading ? 'Désactivation...' : 'Supprimer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeactivateServiceModal;